import en from './en.yaml'
import zh from './zh.yaml'
import ja from './ja.yaml'

export default {
  en,
  zh,
  ja
}



// WEBPACK FOOTER //
// ./i18n/2016/messages/index.js